import React from 'react';
import { styled } from '@mui/material/styles';
import { IBasketResourceV10, IItemReadResourceV10 } from './model/Basket';
import { ViewBillOrderItem } from 'components/bill/ui/ViewBill/ViewBillOrderItem';
import { ViewBillContentSection } from 'components/bill/ui/ViewBill/ViewBillContentSection';
import { Box, Button } from '@mui/material';

import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';
import { useTranslation } from 'react-i18next';
import { isDefined } from 'lib/typeInference';

const StyledButton = styled(Button)(({ theme }) => ({
    color: theme.palette.hint,
    fontSize: theme.spacing(2),
    textTransform: 'capitalize',
    fontWeight: 400
}));

interface BasketItemsProps {
    calculatedBasket: IBasketResourceV10;
    onItemClick: (index: number, item?: IItemReadResourceV10) => void;
    onOpenClearBasketDialog: () => void;
}

export const BasketItems: React.FC<React.PropsWithChildren<BasketItemsProps>> = ({
    calculatedBasket,
    onItemClick,
    onOpenClearBasketDialog
}) => {
    const { t } = useTranslation();

    const basket = useSelector((state: ApplicationState) => state.basket);
    const renderOrderItem = React.useCallback(
        (item: IItemReadResourceV10, index: number) => (
            <ViewBillOrderItem
                onClick={onItemClick}
                index={index}
                orderItem={item}
                allItems={calculatedBasket?.items ?? []}
                key={item.id}
            />
        ),
        [calculatedBasket, onItemClick]
    );
    const filteredBasketItems = React.useMemo(
        () => calculatedBasket.items.filter(item => !isDefined(item.parentReferenceId)),
        [calculatedBasket.items]
    );
    return (
        <ViewBillContentSection bottomSpacing={2}>
            {calculatedBasket.items.length > 0 && basket.items.length > 0 && (
                <>
                    {filteredBasketItems.map(renderOrderItem)}
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <StyledButton onClick={onOpenClearBasketDialog}>
                            {t('CHECKOUT_EMPTY_BASKET_TITLE')}
                        </StyledButton>
                    </Box>
                </>
            )}
        </ViewBillContentSection>
    );
};
